module.exports = __webpack_public_path__ + "img/plus-inactive.959ef100.svg";